import { remoteRoleToUserRole } from "../enums/SDKUserRole";
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Object Definition
export class WorkspaceInvitation {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model) {
        this.id = model.id;
        this.email = model.email;
        this.createdAt = new Date(model.createdAt);
        this.resentAt = model.resentAt ? new Date(model.resentAt) : null;
        this.role = remoteRoleToUserRole[model.role];
        this.seatType = model.seatType;
        this.workspaceId = model.workspaceId;
        this.invitedBy = model.invitedBy;
        this.effectiveRole = remoteRoleToUserRole[model.effectiveRole];
        this.effectiveSeatType = model.effectiveSeatType;
    }
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Serialization & Deserialization
    toRemote() {
        return {
            id: this.id,
            email: this.email,
            createdAt: this.createdAt,
            resentAt: this.resentAt,
            role: this.role,
            seatType: this.seatType,
            workspaceId: this.workspaceId,
            invitedBy: this.invitedBy,
            effectiveRole: this.effectiveRole,
            effectiveSeatType: this.effectiveSeatType,
        };
    }
    toTransport() {
        return this.toRemote();
    }
    static fromTransport(model) {
        return new WorkspaceInvitation(model);
    }
}
